import { configureStore } from '@reduxjs/toolkit'
import connectionReducer from '@/features/connection/connectionSlice'
import dealersReducer from '@/features/dealers/dealersSlice'
import plansReducer from '@/features/plans/plansSlice'
import exceptionsReducer from '@/features/exceptions/exceptionsSlice'
import uiReducer from '@/features/ui/uiSlice'

export const store = configureStore({
  reducer: {
    connection: connectionReducer,
    dealers: dealersReducer,
    plans: plansReducer,
    exceptions: exceptionsReducer,
    ui: uiReducer
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
